import React, { useMemo } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { useStore } from 'react-redux';
import DesktopTableRow from './table.desktop-table-row';
import { Grid } from '@material-ui/core';
import { useStyles } from './table';
import Checkbox from '@material-ui/core/Checkbox';
import MobilePagination from './mobile.pagination';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function DesktopTable({
  get_rows,
  fetchAPI,
  checkboxes,
  handleCheckBox,
  checkAllParcel,
  allSelectedCheck,
  paginationProps,
  loading,
}: any) {
  const classes = useStyles();
  const store = useStore();

  return (
    <Grid xs={12} md={12} className="hidden sm:block">
      <Grid item xs={12} md={12} className={classes.onlyPrint}>
        <br />
        <h1 style={{ textAlign: 'center' }}>{process.env.REACT_APP_COURIER_COMPANY_NAME}</h1>
      </Grid>
      <Grid item xs={12} md={12}>
        <MobilePagination {...paginationProps} />
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
              <TableHead style={{ backgroundColor: 'lightgray' }}>
                <TableRow>
                  <TableCell className={classes.hidePrint} align="left">
                    <Checkbox checked={allSelectedCheck} onChange={checkAllParcel} />
                  </TableCell>
                  <TableCell className={classes.printStyle} align="left">
                    <b>No.</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="center">
                    <b>Parcel ID</b>
                    <hr style={{ margin: 0 }} />
                    <b>Memo No.</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="center">
                    <b>Merchant</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="left">
                    <b>Customer</b>
                    <hr style={{ margin: 0 }} />
                    <b>Phone</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="left">
                    <b>Address</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="left">
                    <b>Status</b>
                  </TableCell>
                  <TableCell className={classes.printStyle} align="right">
                    <b>Receive</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {get_rows.map((row: any, i: number) => (
                  <DesktopTableRow
                    row={row}
                    serial={(paginationProps.currentPage - 1) * paginationProps.limit + i + 1}
                    key={row.id}
                    fetchAPI={fetchAPI}
                    checkboxes={checkboxes}
                    handleCheckBox={handleCheckBox}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <MobilePagination {...paginationProps} />
      </Grid>

      <Grid item xs={12} md={12} className={classes.onlyPrint}>
        <br />
        <div style={{ textAlign: 'center' }}>
          <Table
            style={{
              maxWidth: '10cm',
            }}
            size="small"
            aria-label="simple table"
          >
            <TableBody>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Date
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {moment().format('DD MMM YYYY')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Rider Name
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {`${store.getState().auth?.user?.rider?.id} - ${store.getState().auth?.user?.name}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total Parcel:
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {get_rows.length}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total COD:
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  {get_rows.reduce((prev: number, curr: any) => prev + (curr.COD ?? 0), 0)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Bkash/Nagad &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  &nbsp;
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Total cash received &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  &nbsp;
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tdBorder} align="left">
                  Due &nbsp;
                </TableCell>
                <TableCell className={classes.tdBorder} align="center">
                  &nbsp;
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </Grid>
    </Grid>
  );
}
